import React from 'react';
import { Divider } from './ui/Divider';
export function RevelationSection() {
  const steps = [{
    num: '01',
    title: 'The Bio-Identical Hunger Reset',
    desc: 'Stop the afternoon sugar crashes in 48 hours.'
  }, {
    num: '02',
    title: 'Estrogen Detox',
    desc: 'Use specific cruciferous "activators" to flush out the bloating.'
  }, {
    num: '03',
    title: 'The 72h Sleep Clock Reset',
    desc: 'Re-sync your circadian rhythm so you wake up refreshed, not exhausted.'
  }];
  return <section className="bg-cream py-24 px-6" data-id="element-53">
      <div className="max-w-5xl mx-auto" data-id="element-54">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-55">
          <h2 className="text-4xl md:text-5xl mb-8 leading-tight" data-id="element-56">
            The secret isn't a new diet.
            <br data-id="element-57" />
            <span className="italic text-olive-light" data-id="element-58">
              It's Hormonal Safety.
            </span>
          </h2>
          <p className="text-lg md:text-xl text-warm-dark/80 leading-relaxed" data-id="element-59">
            After 35, your body becomes hypersensitive to Cortisol (the stress
            hormone) and enters "Survival Mode." In this state, your body
            refuses to burn fat, it kills your libido to save energy, and it
            blocks your deep sleep to keep you "alert."
          </p>
        </div>

        <Divider className="mb-16" data-id="element-60" />

        <div className="text-center mb-12" data-id="element-61">
          <h3 className="text-2xl md:text-3xl mb-4" data-id="element-62">
            The Hormonal Sovereignty Protocol
          </h3>
          <p className="text-warm-dark/70 max-w-2xl mx-auto" data-id="element-63">
            A 3-step system to flip the "Safety Switch" in your brain using
            natural, kitchen-based bio-hacks.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-64">
          {steps.map((step, index) => <div key={index} className="relative bg-sage-light p-8 rounded-2xl border border-sage/20 pt-12" data-id="element-65">
              <div className="absolute -top-6 left-8 w-12 h-12 bg-olive-gold text-cream rounded-full flex items-center justify-center font-heading text-xl font-bold shadow-lg" data-id="element-66">
                {step.num}
              </div>
              <h4 className="text-xl font-bold text-olive-gold mb-3 font-body" data-id="element-67">
                {step.title}
              </h4>
              <p className="text-warm-dark/80 leading-relaxed" data-id="element-68">{step.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}